import { render, staticRenderFns } from "./DBMenu.vue?vue&type=template&id=476d3c59&scoped=true&"
import script from "./DBMenu.vue?vue&type=script&lang=ts&"
export * from "./DBMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DBMenu.vue?vue&type=style&index=0&id=476d3c59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d3c59",
  null
  
)

export default component.exports